import Departaments from './Departaments'

export default Departaments
